//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { DropdownProps, Form, Grid } from "semantic-ui-react";
import { useGraphEdgeHandlers } from "../../graph-modeller/GraphProvider";
import { NodeMappings } from "../../types";
import { useFileAndEdgeModifiers } from "../hooks/useFileAndEdgeModifiers";
import { useDataloaderStore } from "../../DataloaderStore";

export const EdgeSourceKeySelector = () => {
  const { edgeMappings } = useDataloaderStore().getDeploymentDataloaderState();
  const { getEdge } = useGraphEdgeHandlers();
  const { assignSourcePrimaryKeyToEdgeInGlobalStore, getCurrentSourceNodeOfEdgeFromGlobalStore, getAssignedSourcePrimaryKeyToEdgeFromGlobalStore } =
    useFileAndEdgeModifiers();

  const [sourceNodeMap, setSourceNodeMap] = useState<NodeMappings | undefined>();
  const [sourceFileID, setSourceFileID] = useState("");

  const { attachedFile, primaryKey } = sourceNodeMap || {};
  const { name: sourceFileName } = attachedFile || {};
  const edge = getEdge();

  const getSourceFieldOptions = () => {
    const correspondingEdge = edgeMappings[edge?.id || ""];
    if (isEmpty(correspondingEdge)) return [];

    const { attachedFile } = correspondingEdge;
    const { fields } = attachedFile;

    return Object.keys(fields).map((field) => ({
      key: field,
      text: field,
      value: field,
    }));
  };

  useEffect(() => {
    if (edge && !isEmpty(edge)) {
      setSourceNodeMap(getCurrentSourceNodeOfEdgeFromGlobalStore());
      setSourceFileID(getAssignedSourcePrimaryKeyToEdgeFromGlobalStore() || "");
    }
  }, [edge]);

  return (
    <Grid columns={16}>
      <Grid.Column width={16}>
        <Form.Field>
          <p className="para">
            For origin file <b>{sourceFileName}</b> with primary key <b className="mask-data">{primaryKey}</b>, select:
          </p>
        </Form.Field>
      </Grid.Column>
      <Grid.Column width={16}>
        <Form.Field>
          <label htmlFor="sourceIDSelector">Corresponding relation file header</label>
          <Form.Dropdown
            selection
            fluid
            placeholder="Select a column"
            name="sourceIDSelector"
            search
            className="mask-data"
            value={sourceFileID}
            noResultsMessage="No columns found"
            options={getSourceFieldOptions() || []}
            onChange={(_: unknown, data: DropdownProps) => {
              const { value } = data;
              assignSourcePrimaryKeyToEdgeInGlobalStore(String(value));
              setSourceFileID(String(value));
            }}
          />
        </Form.Field>
      </Grid.Column>
    </Grid>
  );
};
